import getCRUDHooks from '../../utils/services/getCRUDHooks';

const {
  useGet: useJurySession,
  useFind: useJurySessions,
  useCreate: useJurySessionCreation,
  useUpdate: useJurySessionUpdate,
  useDelete: useJurySessionDeletion,
} = getCRUDHooks({
  entityName: 'jury-sessions',
});

export {
  useJurySession,
  useJurySessions,
  useJurySessionCreation,
  useJurySessionUpdate,
  useJurySessionDeletion,
};
